import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { HashStorageService } from '@df/browser/storage/hash-storage.service';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { App } from '@df/core/app';
import { UiComponent } from '@df/ui/ui.component';
import { PageFooterVisibilityService } from 'projects/app-default/src/app/layout/page/footer/page-footer-visibility.service';
import { LocalPage } from '../../component/page.decorator';
import { NBuilderConfig } from './builder.config';
@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class PageBuilderhViewComponentDef extends UiComponent implements OnInit, OnDestroy {
    @Input()
    model?: LocalPage<IPageDataV3>;

    protected isLoaded = false;
    protected abstract storageData: NBuilderConfig.IStorageData;
    protected abstract loadMainProducts(): Promise<any>;
    protected abstract validateData(data: NBuilderConfig.IStorageData);
    constructor(
        private pageFooterVisibilityService: PageFooterVisibilityService,
        private hashStorageService: HashStorageService,
        protected app: App
    ) {
        super();
    }

    override async ngOnInit(): Promise<void> {
        if (!this.storageData.history) {
            this.storageData.history = {};
        }
        this.pageFooterVisibilityService.hide(this);
        this.subscriptions.add(this.app.events.on(NBuilderConfig.updateStorageEvent).subscribe(() => this.saveState()));
        super.ngOnInit();
        await this.loadMainProducts();

        if (this.model?.data?.typeData?.categoryId) {
            await this.app.resources.category.loadAllIds([this.model.data.typeData.categoryId], 2);
        }
        this.detectChanges();
    }
    override ngOnDestroy(): void {
        this.pageFooterVisibilityService.show(this);
        super.ngOnDestroy();
    }
    // save config in hash
    protected saveState() {
        this.hashStorageService.setHash(btoa(JSON.stringify(this.storageData)));
        this.detectChanges();
    }
    // read config from hash
    protected readState() {
        try {
            const dataBase64string = this.hashStorageService.getHash();
            if (dataBase64string) {
                const data = this.getData(dataBase64string);
                // check if data from hash is valid
                if (this.validateData(data)) {
                    this.storageData = data;
                }
            }
            // eslint-disable-next-line no-empty
        } catch (err) {}
    }
    // converts hashed configuration data into object
    private getData(base64string: string): NBuilderConfig.IStorageData {
        const dataString = atob(base64string);
        return JSON.parse(dataString) as NBuilderConfig.IStorageData;
    }
    get typeData() {
        return this.model?.data?.typeData;
    }
}
